module.exports = __webpack_public_path__ + "assets/img/search-blue-dark.ece930bf.svg";